import axios from 'axios';
import i18next from 'i18next';
import Notify from '../../utils/useNotify';
import { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import RatingStars from '../../utils/RatingStars';
import { Dialog, DialogBackdrop, DialogPanel, Radio, RadioGroup } from '@headlessui/react';
import { ArrowPathIcon, EyeIcon, MinusIcon, PlusIcon, XMarkIcon } from '@heroicons/react/24/outline';
import { useRefresh } from '../../utils/RefreshProvider';
import ColorSelector from '../product_details/components/ColorSelector';
import { LeftNewIcon, fileNotFound } from '../../assets/images/icons';
import { ShoppingBagIcon } from '@heroicons/react/24/outline';
import { ExclamationTriangleIcon } from '@heroicons/react/24/outline';
import { hasDiscount } from "../../utils/hasDiscount";

function classNames(...classes) {
  return classes.filter(Boolean).join(' ')
}

export default function Quickview({ slugProduct, smallBtn }) {
  const { t } = useTranslation();
  const token = localStorage.getItem('token');
  const sessionID = localStorage.getItem('session_id');
  const { triggerRefresh } = useRefresh();
  const localhost = process.env.REACT_APP_LOCALHOST;
  const localimg = process.env.REACT_APP_LOCALHOST_IMG;

  const [open, setOpen] = useState(false);
  const [selectedSize, setSelectedSize] = useState(null);
  const [quantity, setQuantity] = useState(1);
  const [product, setProduct] = useState([]);
  const [reviews, setReviews] = useState(0);
  const [productImage, setProductImage] = useState("");
  const [sizes, setSizes] = useState([]);
  const [loading, setLoading] = useState(true);
  const [btnLoading, setBtnLoading] = useState(false);
  const [colors, setColors] = useState([]);
  const [selectedColorId, setSelectedColorId] = useState(null);
  const [stockData, setStockData] = useState([]);
  const [availableSizes, setAvailableSizes] = useState([]);
  const [maxQuantity, setMaxQuantity] = useState(99);
  const [errorMsg, setErrorMsg] = useState(null);
  const isPreorder = product && product.is_nouvel_arrivage === 1 && product.is_nouvel_arrivage_available === 0;

  const fetchView = async () => {
    setOpen(true);
    try {
      const resProds = await axios.get(localhost + "get-product/" + slugProduct);
      const productData = resProds.data.product;
      setProduct(productData);
      // console.log(productData);
      setProductImage(JSON.parse(productData.imgs));
      setReviews(resProds.data.reviews);

      const colorsDt = productData.colors;
      setColors(colorsDt);
      // console.log(colorsDt);
      if (colorsDt.length > 0) {
        setSelectedColorId(colorsDt[0].color_id);
      }

      const stockResponse = await axios.get(localhost + `product-stock/${productData.id}`);
      setStockData(stockResponse.data);
      // console.log(stockResponse.data);

      const isPreorderProduct = productData.is_nouvel_arrivage === 1 && productData.is_nouvel_arrivage_available === 0;

      if (productData.colors.length === 0) {
        const availableSizeIds = stockResponse.data
          .filter(stock => (isPreorderProduct || stock.stock > 0) && !stock.color_id)
          .map(stock => stock.size_id);
        setAvailableSizes(availableSizeIds);
      }
    } catch (err) {
      // console.error(err);
    }
    try {
      const resSizes = await axios.get(localhost + "all-sizes");
      setSizes(resSizes.data);
    } catch (err) {
      // console.error(err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (selectedColorId) {
      const availableSizesForColor = stockData.filter(
        stock => stock.color_id === selectedColorId && (isPreorder || stock.stock > 0)
      ).map(stock => stock.size_id);

      setAvailableSizes(availableSizesForColor);
    }
  }, [selectedColorId, stockData, isPreorder]);

  useEffect(() => {
    if (selectedSize && (colors.length === 0 || selectedColorId)) {
      const stockItem = stockData.find(stock => stock.size_id === selectedSize.id && (colors.length === 0 ? stock.color_id === null : stock.color_id === selectedColorId));

      if (stockItem) {
        if (isPreorder) {
          setMaxQuantity(99);
        } else {
          setMaxQuantity(stockItem.stock);
        }

        if (!isPreorder && quantity > stockItem.stock) {
          setQuantity(stockItem.stock);
        }
      } else {
        setMaxQuantity(0);
      }
    } else {
      setMaxQuantity(99);
      if (quantity !== 1) {
        setQuantity(1);
      }
    }
  }, [selectedSize, selectedColorId, stockData, colors.length, quantity, isPreorder]);

  const isSizeAvailable = (sizeId) => {
    if (colors.length === 0) {
      return availableSizes.includes(sizeId);
    }
    return selectedColorId ? availableSizes.includes(sizeId) : false;
  };

  const isColorAvailable = (colorId) => {
    return stockData.some(stock => stock.color_id === colorId && (isPreorder || stock.stock > 0));
  };

  const handleOrder = async (e) => {
    e.preventDefault();
    if (selectedSize === null) {
      Notify("warning", t("size-warning"));
      return;
    }
    if (colors.length > 0) {
      if (selectedColorId === null) {
        Notify("warning", t("color-warning"));
        return;
      }
    }

    let currentSessionID = sessionID;
    let currentToken = token;

    if (currentSessionID === null && currentToken === null) {
      try {
        const SessionData = await axios.get(localhost + "create-session");
        currentSessionID = SessionData.data.session_id;
        localStorage.setItem('session_id', currentSessionID);
      } catch (err) {
        return;
      }
    }
    setBtnLoading(true);

    const stockItem = stockData.find(stock =>
      stock.size_id === selectedSize.id &&
      (colors.length === 0 || stock.color_id === selectedColorId)
    );

    if (!stockItem) {
      Notify("error", t("invalid-selection"));
      setBtnLoading(false);
      return;
    }

    if (!isPreorder && stockItem.stock < quantity) {
      Notify("error", t("insufficient-stock"));
      setBtnLoading(false);
      return;
    }

    const data = {
      product_id: product.id,
      size_id: selectedSize.id,
      color_id: selectedColorId,
      quantity: quantity,
      session_id: currentSessionID,
    };

    try {
      await axios.post(localhost + "user/orders", data, { headers: { Authorization: `Bearer ${token}` } });
      Notify("success", t("add-bag-success"));
      triggerRefresh();
      setOpen(false);
    } catch (err) {
      const errorText = err.response.data?.error;
      setErrorMsg(errorText);
      // localStorage.removeItem("session_id");
    } finally {
      setBtnLoading(false);
      setQuantity(1);
    }
  };

  const closeView = () => {
    setErrorMsg(null);
    setOpen(false);
    setQuantity(0);
  }

  return (
    <>
      {
        !smallBtn ? (
          <div className='flex flex-col gap-2'>
            <a href={`/product/${slugProduct}`} className="px-4 py-2 text-sm max-sm:px-2 max-sm:py-1.5 max-sm:text-xs rounded-md md:rounded-lg text-center relative text-black bg-white hover:bg-white/80 transition-all duration-300 capitalize">{t("view")}</a>
            <button type="button" onClick={fetchView} className="px-4 py-2 text-sm max-sm:px-2 max-sm:py-1.5 max-sm:text-xs rounded-md md:rounded-lg text-center relative text-white bg-black hover:bg-black/80 transition-all duration-300 capitalize">{t("quick-view")}</button>
          </div>
        ) : (
          // <button type='button' onClick={fetchView} className='bg-orange-500 hover:bg-orange-600 p-1 rounded-tl-md'>
          //   <ShoppingBagIcon className='size-7 text-white' />
          // </button>
          <button type='button' onClick={fetchView} className='p-1.5'>
            <svg className="lucide lucide-eye-icon lucide-eye size-5 text-gray-500" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <path d="M2.062 12.348a1 1 0 0 1 0-.696 10.75 10.75 0 0 1 19.876 0 1 1 0 0 1 0 .696 10.75 10.75 0 0 1-19.876 0" />
              <circle cx="12" cy="12" r="3" />
            </svg>
          </button>
        )
      }
      <Dialog open={open} onClose={setOpen} className="relative z-10">
        <DialogBackdrop transition className="fixed inset-0 hidden bg-gray-500/75 transition-opacity data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in md:block" />
        <div className="fixed inset-0 z-10 w-screen overflow-y-auto">
          <div className="flex min-h-full max-sm:min-h-dvh items-stretch justify-center text-center md:items-center md:px-2 lg:px-4">
            <DialogPanel transition className="flex w-full transform text-left text-base transition data-[closed]:translate-y-4 data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in md:my-8 md:max-w-2xl md:px-4 data-[closed]:md:translate-y-0 data-[closed]:md:scale-95 lg:max-w-4xl">
              <div className="relative flex w-full items-center overflow-hidden bg-white px-4 pb-8 pt-14 shadow-2xl sm:px-6 sm:pt-8 md:p-6 lg:p-8">
                <button type="button" onClick={closeView} className="absolute right-4 top-4 text-gray-400 hover:text-gray-500 sm:right-6 sm:top-8 md:right-6 md:top-6 lg:right-8 lg:top-8">
                  <span className="sr-only">Close</span>
                  <XMarkIcon className="size-6" />
                </button>
                {loading ? (
                  <div className="min-h-[500px] w-full flex items-center justify-center">
                    <div className="loading-spinner" />
                  </div>
                ) : (
                  <div className="grid w-full grid-cols-1 items-start gap-x-6 gap-y-2 sm:grid-cols-12 lg:gap-x-8"> {/* gap-y-8 */}
                    {errorMsg && (
                      <div className="col-span-1 sm:col-span-12 flex items-center p-4 mb-2 text-sm text-yellow-800 border border-yellow-200 rounded-lg bg-yellow-50">
                        <ExclamationTriangleIcon className='shrink-0 inline w-5 h-5 me-3' />
                        <div>{t(errorMsg)}</div>
                      </div>
                    )}

                    <div className='relative sm:h-full max-sm:w-full max-sm:h-auto sm:col-span-6'>
                      {product.is_nouvel_arrivage === 1 ? <img src={LeftNewIcon} className='size-14 absolute left-0 top-0 z-10' alt="new" /> : null}
                      <img loading="lazy" alt={product.slug} src={productImage ? localimg + productImage[0] : fileNotFound} className=" rounded-lg bg-gray-100 object-cover" />
                    </div>

                    <div className="sm:col-span-6">
                      <h2 className="text-2xl font-bold text-black sm:pr-12 leading-none">{product.name[i18next.language]}</h2>
                      <section aria-labelledby="information-heading" className="mt-4">
                        <h3 id="information-heading" className="sr-only">Product information</h3>
                        {
                          hasDiscount(product) ? (<>
                            <div className="flex items-end text-red-500 line-through">
                              <p className="text-base leading-none">{product.old_price}</p>
                              <span className='ml-0.5 text-xs leading-none pb-0.5'>MAD</span>
                            </div>
                            <div className="flex items-end">
                              <p className="text-2xl leading-none">{product.price}</p>
                              <span className='ml-0.5 text-xs leading-none pb-0.5'>MAD</span>
                            </div>
                          </>) : (
                            <div className="flex items-end">
                              <p className="text-2xl leading-none">{product.price}</p>
                              <span className='ml-0.5 text-xs leading-none pb-0.5'>MAD</span>
                            </div>
                          )}

                        {/* <div className="mt-2">
                          <h4 className="sr-only">Reviews</h4>
                          <div className="flex items-center">
                            {<RatingStars rating={product.rating} size="16px" />}
                            <p className="ml-3 text-sm font-medium text-orange-600 hover:text-orange-500">
                              {reviews} {t("reviews")}
                            </p>
                          </div>
                        </div> */}

                      </section>
                      <section aria-labelledby="options-heading" className="mt-4">
                        <h3 id="options-heading" className="sr-only">Product options</h3>
                        <form onSubmit={handleOrder}>
                          <fieldset aria-label="Choose a quantity">
                            <legend className="text-sm font-medium text-black">{t("quantity")}</legend>
                            <div className="mt-3 flex items-center gap-2">
                              <button type="button" onClick={() => setQuantity(Math.max(1, quantity - 1))} disabled={!selectedSize || quantity <= 1} className={`flex h-8 w-8 items-center justify-center rounded-md border border-gray-300 text-gray-600 ${!selectedSize || quantity <= 1 ? 'opacity-50 cursor-not-allowed' : 'hover:bg-gray-50'}`}>
                                <MinusIcon className='size-4' />
                              </button>
                              <input type="number" value={quantity} onChange={(e) => setQuantity(Math.max(1, Math.min(maxQuantity, Number(e.target.value))))} min="1" max={maxQuantity} disabled={!selectedSize || maxQuantity === 0} className={`h-8 w-16 rounded-md border border-gray-300 text-center text-black focus:outline-none focus:ring-2 focus:ring-orange-500 ${!selectedSize || maxQuantity === 0 ? 'bg-gray-100 cursor-not-allowed' : ''}`} />
                              <button type="button" onClick={() => setQuantity(Math.min(maxQuantity, quantity + 1))} disabled={!selectedSize || quantity >= maxQuantity} className={`flex h-8 w-8 items-center justify-center rounded-md border border-gray-300 text-gray-600 ${!selectedSize || quantity >= maxQuantity ? 'opacity-50 cursor-not-allowed' : 'hover:bg-gray-50'}`} >
                                <PlusIcon className='size-4' />
                              </button>
                            </div>
                          </fieldset>
                          <div className='my-4'>
                            {colors.length > 0 && (
                              <div className=''>
                                <ColorSelector colors={colors.map(color => ({ ...color, disabled: !isColorAvailable(color.color_id) }))} t={t} selectedColorId={selectedColorId} setSelectedColorId={setSelectedColorId} />
                              </div>
                            )}
                          </div>
                          <fieldset aria-label="Choose a size" className="mt-4">
                            <div className="flex items-center justify-between">
                              <div className="text-sm font-medium text-black">{t("size")}</div>
                              <div />
                            </div>
                            <RadioGroup value={selectedSize} onChange={setSelectedSize} className="mt-2 grid grid-cols-4 gap-3">
                              {sizes.map((prodSize, index) => {
                                const isAvailable = isSizeAvailable(prodSize.id);
                                return (
                                  <Radio key={index} value={prodSize} disabled={!isAvailable} className={classNames(
                                    isAvailable
                                      ? 'cursor-pointer bg-white text-black shadow-sm'
                                      : 'cursor-not-allowed bg-gray-50 text-gray-200 hidden',
                                    'group relative flex items-center justify-center rounded-md border px-4 py-3 text-sm font-medium uppercase hover:bg-gray-50 focus:outline-none data-[focus]:ring-2 data-[focus]:ring-orange-500 sm:flex-1',
                                  )}>
                                    <span>{prodSize.name}</span>
                                    {isAvailable ? (
                                      <span className="pointer-events-none absolute -inset-px rounded-md border-2 border-transparent group-data-[focus]:border group-data-[checked]:border-orange-500" />
                                    ) : (
                                      <span className="pointer-events-none absolute -inset-px rounded-md border-2 border-gray-200">
                                        <svg stroke="currentColor" viewBox="0 0 100 100" preserveAspectRatio="none" className="absolute inset-0 size-full stroke-2 text-gray-200">
                                          <line x1={0} x2={100} y1={100} y2={0} vectorEffect="non-scaling-stroke" />
                                        </svg>
                                      </span>
                                    )}
                                  </Radio>
                                );
                              })}
                            </RadioGroup>
                          </fieldset>

                          <div className='grid grid-cols-1 md:grid-cols-2 gap-2 mt-6 md:mt-4'>
                            <button type="submit" className={`col-span-1 flex items-center justify-center rounded-md border border-transparent px-4 py-3 text-base font-medium text-white outline-none ${btnLoading ? 'bg-orange-400 cursor-not-allowed' : 'bg-orange-600 hover:bg-orange-700'}`} disabled={btnLoading}>
                              {btnLoading ? <span className="flex justify-center items-center">
                                <ArrowPathIcon className="animate-spin text-white size-6 mr-2" />
                                {t("loading")}
                              </span> : t("add-bag")}
                            </button>

                            <button type="button" onClick={closeView} className="col-span-1 border border-gray-300 text-black hover:bg-gray-100 focus:outline-none focus-visible:ring-2 focus-visible:ring-gray-500 flex w-full items-center justify-center rounded-md px-4 py-3 text-base font-medium">
                              {t("cancel")}
                            </button>
                          </div>

                        </form>
                      </section>
                    </div>
                  </div>
                )}
              </div>
            </DialogPanel>
          </div>
        </div>
      </Dialog>
    </>
  );
}
